// The persisted live domains (primary and secondaries) of a certificate-managed frontend
// grouping — the only domains that hold a managed TLS certificate and so the only ones with
// a provisioning badge. The staging domain rides the environment wildcard certificate.
export function certificateDomains(domains, certManaged) {
  return (domains || []).filter((d) => d && d.frontend && certManaged(d.frontend) && !(d.isStaging || d.staging));
}

// store-manager serialises FrontendType.certManager through its Lombok getter, so /configs
// ships `isCertManager`; the bare `certManager` spelling is the declared config shape.
export function certManagedBy(frontendTypes) {
  return (key) => {
    const type = (frontendTypes || []).find((t) => t && t.type === key) || {};
    return !!(type.isCertManager || type.certManager);
  };
}
